import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Radio } from 'antd';
import { Typography, Button, DatePicker, Space, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';


function ImportExcel() {
    const [searchParams, _] = useSearchParams();

    const [value, setValue] = useState('month');

    const officeId = searchParams.get("officeId");

    function onChange(e) {
        setValue(e.target.value);
    }

    const [enabled, setEnabled] = useState(false);
    const [date, setDate] = useState(null);

    function onChangeDate(_, newDateString) {
        setDate(newDateString);
        setEnabled(true);
    }

    function uploadCsv() {

    }
    const props = {
        name: 'file',
        action: `${process.env.REACT_APP_BACKEND_URL}/upload/excel`,
        method: 'post',
        headers: {
            authorization: 'authorization-text',
        },
        data: {
            officeId,
            date
        },
        onChange(info) {
            if (info.file.status === 'done') {
                if (info.file.response.result === 'unmapped') {
                    message.warning(`There are some unmapped account in the chart. Please map and retry.`);
                } else if (info.file.status === 'done') {
                    message.success(`File imported successfully.`);
                }
            } else if (info.file.status === 'error') {
                message.error(`File import failed.`);
            }
        },
    };

    return (
        <div>
            <Space direction="vertical" size={12}>
                <Typography.Title level={3}>Schedule Accounts Pull For Specific Month</Typography.Title>
                <DatePicker picker="month" onChange={onChangeDate} />                
                <Upload {...props}>
                    <Button disabled={!enabled} icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
            </Space>
        </div>
    );
};

export default ImportExcel;
